// Bus tí hon để mở dialer VOIP từ ngoài (vd menu avatar) mà KHÔNG static-import
// cả FloatingCallWidget (giữ widget lazy, không phình bundle chính).
export const VOIP_OPEN_DIALER_EVENT = 'voip:open-dialer';
export function openVoipDialer() {
  try { window.dispatchEvent(new CustomEvent(VOIP_OPEN_DIALER_EVENT)); } catch { /* noop */ }
}
